import { createFileRoute } from "@tanstack/react-router";

import { OrganizationSettings } from "../components/org/OrganizationSettings";

export const Route = createFileRoute("/settings/organization")({
  component: OrganizationSettings,
});
